
export enum MimeEnums {
    jpeg = 'image/jpeg',
    png = 'image/png',
    gif = 'image/gif',
    bmp = 'image/bmp',
    svg = 'image/svg+xml',
    eps = 'application/postscript',

}

export const  getMimeName = (key: string): string => {
    switch(key){
        case MimeEnums.jpeg:
            return 'jpeg';
        case MimeEnums.png:
            return 'jpeg';
        case MimeEnums.gif:
            return 'gif';
        case MimeEnums.bmp:
            return 'bmp';
        case MimeEnums.svg:
            return 'svg';
        case MimeEnums.eps:
            return 'eps';
    };
    return '';
}

export const  isMimeVector = (key: string): boolean => {
    switch(key){
        case MimeEnums.svg:
        case MimeEnums.eps:
            return true;
    };
    return false;
}
